export function getLevenshteinDistance(a: string, b: string): number {
  const matrix = [];
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) == a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
      }
    }
  }
  return matrix[b.length][a.length];
}

export function soundex(s: string): string {
  let a = s.toLowerCase().split('');
  let f = a.shift() || '';
  let r = '';
  let codes: Record<string, string> = {
      a: '', e: '', i: '', o: '', u: '', y: '',
      b: '1', f: '1', p: '1', v: '1',
      c: '2', g: '2', j: '2', k: '2', q: '2', s: '2', x: '2', z: '2',
      d: '3', t: '3',
      l: '4',
      m: '5', n: '5',
      r: '6'
  };
  r = f +
      a.map((v, i, a) => codes[v] === codes[a[i - 1]] ? '' : codes[v])
      .filter(v => v !== '')
      .join('');
  return (r + '000').slice(0, 4).toUpperCase();
}

export function checkNameSimilarity(newName: string, existingNames: string[]): string | null {
  const target = newName.toLowerCase().trim();
  const targetSoundex = soundex(newName);
  
  for (const existing of existingNames) {
    const compare = existing.toLowerCase().trim();
    if (target === compare) return `Identical to existing name: ${existing}`;
    
    const distance = getLevenshteinDistance(target, compare);
    if (distance <= 2 && target.length > 4) {
      return `Visually very similar to ${existing}`;
    }
    
    if (targetSoundex === soundex(existing) && target.charAt(0) === compare.charAt(0)) {
      return `Phonetically similar to ${existing}`;
    }
  }
  return null;
}
